import { redirect } from '@tanstack/react-router';
import { getCompanyStore } from './company-store';

export function requireLevel(minLevel: number) {
  return () => {
    const { level } = getCompanyStore();
    if (level < minLevel) {
      throw redirect({ to: '/' });
    }
  };
}
